import React from "react";
import moment from "moment";
import { Box } from "@mui/material";
import CheckoutProduct from "./CheckoutProduct";
import CurrencyFormat from "react-currency-format";

const Order = ({ order }) => {
	return (
		<Box sx={{ borderBottom: "1px solid darkgray", pb: 2, pt: 3 }}>
			<Box sx={{ fontWeight: "bold", fontSize: "22px" }}>
				{moment.unix(order.created).format("MMM Do YYYY")}
			</Box>
			<CurrencyFormat
				renderText={(value) => (
					<>
						<Box sx={{ fontSize: "14px", color: "#757575" }}>{value}</Box>
					</>
				)}
				decimalScale={2}
				value={order.amount / 100}
				displayType={"text"}
				thousandSeparator={true}
				prefix={"$"}
			/>
			<Box sx={{ fontSize: "14px", color: "#757575" }}>#{order.id}</Box>
			<Box>
				<CurrencyFormat
					renderText={(value) => <>{value}</>}
					decimalScale={2}
					value={order.amount / 100}
					displayType={"text"}
					thousandSeparator={true}
					prefix={"$"}
					// value={getBasketTotal(basket)}
				/>
			</Box>
			{order.basket?.map((item) => (
				<CheckoutProduct item={item} />
			))}
		</Box>
	);
};

export default Order;
